import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import BasicTextField from "../../../mui/TextField";

const ParentFeedBackForm = () => {
    return (
        <Box
            sx={{
                minWidth: "600px",
            }}
        >
            <Typography
                variant="h4"
                sx={{
                    fontSize: "20px",
                    pb: "20px",
                    mb: "10px",
                    borderBottom: "1px solid #000",
                }}
            >
                Parent Feedback
            </Typography>
            <Stack
                gap={2}
                sx={{
                    borderBottom: "1px solid #000",
                    pb: "15px",
                    mb: "20px",
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        fontSize: "20px",
                        textAlign: "center",
                    }}
                >
                    CRO COMMUNICATION
                </Typography>

                <BasicTextField
                    label="Admission Confirmation Procedures"
                    disabled
                />
                <BasicTextField label="Proper and Timely Response" disabled />
                <BasicTextField label="Method of Communication" disabled />
                <BasicTextField label="Student Status Updates" disabled />
                <BasicTextField label="Behaviour Towards Parent" disabled />
                <BasicTextField label="Overall Satisfaction" disabled />
            </Stack>

            <Stack
                gap={2}
                sx={{
                    borderBottom: "1px solid #000",
                    pb: "15px",
                    mb: "20px",
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        fontSize: "20px",
                        textAlign: "center",
                    }}
                >
                    TRAINER REMARKS
                </Typography>

                <BasicTextField label="Trainer Satisfaction" disabled />
                <BasicTextField label="Trainer and Student Bond" disabled />
                <BasicTextField label="Doubt Clearance" disabled />
                <BasicTextField label="Punctuality" disabled />
                <BasicTextField label="Behaviour" disabled />
                <BasicTextField label="Background" disabled />
                <BasicTextField label="Grooming" disabled />
                <BasicTextField
                    label="Extracurricular Activities/Games"
                    disabled
                />
                <BasicTextField label="Trainer-Parent Communication" disabled />
                <BasicTextField label="HomeWorks/Activities Status" disabled />
            </Stack>

            <Stack
                gap={2}
                sx={{
                    borderBottom: "1px solid #000",
                    pb: "15px",
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        fontSize: "20px",
                        textAlign: "center",
                    }}
                >
                    FEEDBACK FROM PARENT
                </Typography>

                <BasicTextField label="Student Progress" disabled />
                <BasicTextField label="Interval Feedback" disabled />
                <BasicTextField
                    label="Suggestions (if any)"
                    disabled
                    multiline
                    rows={3}
                />
            </Stack>
        </Box>
    );
};

export default ParentFeedBackForm;
